// extracted by mini-css-extract-plugin
module.exports = {"g1wim0i0":"g1wim0i0","loader":"loader"};